import React from 'react';
import { PanelLeftOpen } from 'lucide-react';
import { Button } from '../ui/button';
import { useDashboard } from '../../contexts/DashboardContext';
import { useAuth } from '../../contexts/AuthContext';
import { getNavSections } from './navSections';

// Узкая полоска вместо свёрнутой панели: разделы переключаются иконками,
// фильтры доступны после разворачивания
const SidebarRail = ({ onExpand, expandButtonRef }) => {
  const { user } = useAuth();
  const { activeSection, setActiveSection } = useDashboard();
  const sections = getNavSections(user);

  return (
    <nav className="h-full w-12 flex-shrink-0 flex flex-col items-center gap-1 py-3 bg-sidebar border-r border-border overflow-y-auto" aria-label="Разделы">
      <Button
        ref={expandButtonRef}
        variant="ghost"
        size="icon"
        className="h-9 w-9 mb-2"
        onClick={onExpand}
        aria-expanded="false"
        title="Развернуть панель"
        aria-label="Развернуть панель"
      >
        <PanelLeftOpen className="h-4 w-4" />
      </Button>
      {sections.map(section => {
        const IconComponent = section.icon;
        return (
          <Button
            key={section.id}
            variant={activeSection === section.id ? 'secondary' : 'ghost'}
            size="icon"
            className="h-9 w-9"
            onClick={() => setActiveSection(section.id)}
            aria-current={activeSection === section.id ? 'page' : undefined}
            title={section.name}
            aria-label={section.name}
          >
            <IconComponent className="h-4 w-4" />
          </Button>
        );
      })}
    </nav>
  );
};

export default SidebarRail;
